export default async function guest({store, to}: { store: any, to?: { name?: string | symbol | null } }) {
    console.log('%c -- MIDDLEWARE -- GUEST ✅', 'color: white; background: green; padding: 2px; font-weight: bold;');

    try {
        // Retrieve authentication token from Vuex store
        const token = store.getters['auth/token'];
        const isAuthenticated = store.getters['auth/check'];

        console.log('%c 🔑 Auth Token:', 'color: cyan; font-weight: bold;', token);
        console.log('%c 👤 Is Authenticated?', 'color: cyan; font-weight: bold;', isAuthenticated);

        // Allow incomplete signups to finish setup while authenticated.
        if (token && to?.name === 'company.next-step') {
            console.log('%c ✅ Guest Middleware: Allowing company.next-step for authenticated incomplete signup', 'color: lime; font-weight: bold;');
            return true;
        }

        // Check if the user is authenticated
        if (token) {
            console.warn('%c 🚪 Guest Middleware: User is logged in - Redirecting...', 'color: orange; font-weight: bold;');
            return false;
        }

        console.log('%c ✅ Guest Middleware: User is NOT logged in', 'color: lime; font-weight: bold;');
        return true;
    } catch (error) {
        console.error('%c ❌ Guest Middleware Error:', 'color: red; font-weight: bold;', error);
        return false; // Fallback to assuming user is logged in to prevent unintended access
    }
}
